import { Disclosures } from "./Disclosures";

export default Disclosures;
